import React, { useState } from "react";
import { FaBullseye, FiChevronUp, FiChevronDown } from "react-icons/all";
import {
  useMountedValue,
  makeAnimatedComponent,
  bInterpolate,
} from "react-ui-animate";
import { useNavigation } from "react-uicomp";

const AnimatedUl = makeAnimatedComponent("ul");

export const HeaderDropdown = ({ path, name }) => {
  const { navigation } = useNavigation();
  const { navigate, routes } = navigation;

  const [dropdownActive, setDropdownActive] = useState(false);
  const open = useMountedValue(dropdownActive, [0, 1, 0]);

  const openDropdown = () => {
    setDropdownActive(true);
  };

  const closeDropdown = () => {
    setDropdownActive(false);
  };

  const subNav = Object.keys(routes)
    .filter((route) => routes[route].props === name)
    .map((route) => routes[route]);

  return (
    <li
      className="header-navitem"
      onMouseOver={openDropdown}
      onMouseLeave={closeDropdown}
      onClick={() => (!!subNav?.length ? false : navigate(path))}>
      <a href={path} onClick={(e) => e.preventDefault()}>
        {name}
      </a>

      {subNav && subNav.length > 0
        ? open(
            (animation, mounted) =>
              mounted && (
                <AnimatedUl
                  style={{
                    opacity: animation.value,
                    transformOrigin: "center top",
                    transform: bInterpolate(animation.value, [
                      "scaleY(0.8)",
                      "scaleY(1)",
                    ]),
                  }}
                  className="header-navitem-sub-navigation">
                  {subNav.map(({ path, name }, i) => (
                    <li key={i} className="header-subnavitem">
                      <a
                        href={path}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          navigate(path);
                        }}>
                        {name}
                      </a>
                    </li>
                  ))}
                </AnimatedUl>
              ),
          )
        : null}
    </li>
  );
};

export const HeaderDropdownMobile = ({ path, name }) => {
  const { navigation } = useNavigation();
  const { navigate, routes } = navigation;
  const [allFabrics, setAllFabrics] = useState(false);

  const allFabricHandler = (e) => {
    e.stopPropagation();
    setAllFabrics(!allFabrics);
  };

  const subNav = Object.keys(routes)
    .filter((route) => routes[route].props === name)
    .map((route) => routes[route]);

  return (
    <>
      <li
        className="sidebar-list-item"
        onClick={(e) =>
          !!subNav?.length ? allFabricHandler(e) : navigate(path)
        }>
        <p>{name}</p>
        {!!subNav?.length ? (
          allFabrics ? (
            <FiChevronUp />
          ) : (
            <FiChevronDown />
          )
        ) : null}
      </li>
      {subNav && allFabrics && subNav.length > 0 ? (
        <>
          {subNav.map(({ path, name }, i) => (
            <li
              className="sidebar-list-item mini"
              onClick={(e) => {
                navigate(path);
              }}>
              {name}
            </li>
          ))}
        </>
      ) : null}
    </>
  );
};
